import script from "./TressTextAreaInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressTextAreaInput.vue?vue&type=script&lang=ts&setup=true"

import "./TressTextAreaInput.vue?vue&type=style&index=0&id=886b8898&lang=scss"

const __exports__ = script;

export default __exports__